import React from "react";
import { useCharacter } from "../../../hooks/use-character";
import Field from "../../ui/Field";

interface Props {
  className?: string;
}

const Face: React.FC<Props> = ({ className }) => {
  const {
    mode,
    handleFaceChange,
    character: {
      face: {
        nose_width,
        nose_height,
        nose_length,
        nose_bridge,
        nose_bridge_shift,
        nose_tip,
        brow_height,
        neck_width,
        lips,
      },
    },
  } = useCharacter();

  return (
    <div className={`space-y-8 ${className}`}>
      <Field
        label="Lățimea nărilor"
        description="Reglează lățimea nărilor."
        type="stepper"
        initialValue={nose_width}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ nose_width: Number(value) })}
      />

      <Field
        label="Mărimea nasului"
        description="Modifică înălțimea nasului."
        type="stepper"
        initialValue={nose_height}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ nose_height: Number(value) })}
      />

      <Field
        label="Lungimea Vârfului Nasului"
        description="Setează lungimea vârfului nasului."
        type="stepper"
        initialValue={nose_length}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ nose_length: Number(value) })}
      />

      <Field
        label="Adâncimea Nasului"
        description="Controlează adâncimea podului nasului."
        type="stepper"
        initialValue={nose_bridge}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ nose_bridge: Number(value) })}
      />

      <Field
        label="Vârful Nasului"
        description="Ajustează forma vârfului nasului."
        type="stepper"
        initialValue={nose_tip}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ nose_tip: Number(value) })}
      />

      <Field
        label="Direcția nasului"
        description="Schimbă direcția podului nasului."
        type="stepper"
        initialValue={nose_bridge_shift}
        min={0}
        max={1}
        onChange={(value) =>
          handleFaceChange({ nose_bridge_shift: Number(value) })
        }
      />

      <Field
        label="Înălțimea sprâncenelor"
        description="Modifică cât de sus sau jos sunt sprâncenele."
        type="stepper"
        initialValue={brow_height}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ brow_height: Number(value) })}
      />

      <Field
        label="Lățime gât"
        description="Reglează lățimea gâtului."
        type="stepper"
        initialValue={neck_width}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ neck_width: Number(value) })}
      />

      <Field
        label="Grosimea Buzelor"
        description="Setează grosimea buzelor."
        type="stepper"
        initialValue={lips}
        min={0}
        max={1}
        onChange={(value) => handleFaceChange({ lips: Number(value) })}
      />
    </div>
  );
};

export default Face;
